/* eslint-disable no-console */
import axios, { AxiosResponse } from "axios";
import { Moment } from "moment";

import { TransactionsMapper } from "../../mapper";
import mockData from "../../../tests/mocks/mockGetTransaction2.json";

type GetTransactionsBody = {
  startDate?: number; // Uses Date.getTime()
  endDate?: number; // Uses Date.getTime()
  transactionType: TransactionT;
  services?: string | "ALL";
  partners?: string | "ALL";
  mileTypes?: MileT;
  isSendEmail?: boolean;
  keyword?: string;
};

type IgetTransactions = {
  apiDomain: string;
  jwt: string;
  startDate: Moment;
  endDate: Moment;
  transactionType?: TransactionT;
  mileTypes?: MileT;
  isSendEmail?: boolean;
  golPremiumEnabled?: boolean;
};

const getTransactions = async ({
  apiDomain,
  jwt,
  startDate,
  endDate,
  transactionType = "ALL",
  mileTypes = "ALL",
  isSendEmail = false,
  golPremiumEnabled = false,
}: IgetTransactions) => {
  const url = `${apiDomain}/transactions/v1/transactions`;

  const body: GetTransactionsBody = {
    startDate: startDate.valueOf(),
    endDate: endDate.valueOf(),
    transactionType,
    mileTypes,
    services: "ALL",
    isSendEmail,
  };

  const vbzDebug = localStorage.getItem("vbzDebug");

  if (vbzDebug) {
    const mockResponse = [...mockData];
    mockResponse.pop();
    return TransactionsMapper(mockResponse, golPremiumEnabled);
  }

  return axios
    .post(url, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    })
    .then((response: AxiosResponse<TransactionsResponse>) => {
      const transactions = [...response.data];
      transactions.pop();
      return TransactionsMapper(transactions, golPremiumEnabled);
    })
    .catch((error) => {
      return error?.response?.data?.data.error_code;
    });
};

export { getTransactions };
